export default "__VITE_ASSET__BOBSg33v__"